export function sameHeight() {
  function setSameHeight() {
    // data-same-height属性を持つすべての要素を取得
    const elements = document.querySelectorAll('[data-same-height]');
    const groups = {};

    // data-same-heightごとにグループ化
    elements.forEach(element => {
      const group = element.getAttribute('data-same-height');
      if (!groups[group]) {
        groups[group] = [];
      }
      groups[group].push(element);
    });

    // 各グループの中で最大の高さに要素の高さを揃える
    Object.keys(groups).forEach(group => {
      let maxHeight = 0;

      // 高さをリセットして最大の高さを計算
      groups[group].forEach(element => {
        element.style.height = ''; // 高さを一旦リセット
        const height = element.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      // 最大の高さに揃える
      groups[group].forEach(element => {
        element.style.height = `${maxHeight}px`;
      });
    });
  }

  // ウィンドウのリサイズ時に高さを揃え直す
  let lastInnerWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    if (lastInnerWidth != window.innerWidth) {
      lastInnerWidth = window.innerWidth;
      setSameHeight();
    }
  })

  // ページロード時に高さを揃える
  document.addEventListener('DOMContentLoaded', setSameHeight);
}